import React from "react";
import SiteConfig from "../../config/SiteConfig.json";
import Dropdown from "./drop-down/dropdown";
import { withPrefix, Link } from "gatsby";

let year = new Date();

const Footer = (props) => (
  <div
    className="container-fluid"
    id="footer"
    style={{
      backgroundColor: SiteConfig.content.footer.style.backgroundColor,
      height: "173px",
      margin: "auto",
    }}
  >
    <div className="container"
      style={{
        width: "90%",
        maxWidth: "1028px",
        marginTop: "0px",
      }}
    >
      <div style={{
        marginTop: "15px"
      }}>
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
          <div style={{
            textAlign: "center",
            }}>
              <a
                className="backToApp"
                href="https://bluemail.me/download/"
                target="_blank"
              >
              &#60; Visit BlueMail.me
              </a>    
          </div>
          <div
            className="footer-download-btn"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <a
              href="https://bluemail.me/download/"
              target="_blank"
              className={"default-btn-white"}
            >
              Download Now
            </a>         
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <a
            href={SiteConfig.seo.copyrightLink}
            style={{ color: "#c2dbee", flex: "1", fontSize: "13px" }}
          >
            © {year.getFullYear()}
            {SiteConfig.seo.copyright}
          </a>
        </div>
      </div>
      
    </div>
  </div>
);

export default Footer;
